import styled from '@emotion/styled';
import { PostButton } from 'components/layout/Main/NewPost/NewPostStyles';

export const DropdownButton = styled(PostButton)`
  && {
    padding: 5px;
  }
`;
